/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
* Goal: Summary of receivables
*/
import { TenantService } from '@src/app/shared/tenant.service';
import { DashboardChart } from '@src/app/shared/dashboard/dashboard-widget/dashboard-chart';


import * as Highcharts from 'highcharts';
import { TenantId } from '@src/app/model/abstract-object';

class TrendData {
    teamId: TenantId
    open: number;
    opened: {month: string, opened: string}[]
    closed: {month: string, closed: string}[]
}

export class RequestTrendChart extends DashboardChart {
    dataUrl = TenantService.ajaxPath + 'omc/dashboard/requestTrend';
    //dataParams = new HttpParams().set('week', 0);

    data: TrendData;

    title = $localize `Request Trend`;
    subTitle = $localize `Requests Opened & Closed`;

    options = [];

    resetChart() {
        // Reset any counters for new data
    }

    getSubTitle() {
        return super.getSubTitle(this.subTitle);
    }

    protected setupData(data: TrendData) {
        this.data = data;
    }

    clickEvent($event) {
        const routeInfo = $event.point.routerLink;
        this.router.navigate(routeInfo);
    }

    protected createChartOptions(): Highcharts.Options {
        const categories = this.data.opened.map(item => item.month);
        const openedSeries = this.data.opened.map(item => item.opened);
        const closedSeries = this.data.closed.map(item => item.closed);     

        return {
            chart: {
                backgroundColor: this.chartBackgroundColor,
                borderRadius: this.chartBorderRadius,
                plotBorderWidth: null,
                type: 'column',
                height: this.height,
                width: this.width
            },
            title: this.getChartTitle(),
            subtitle: this.getSubTitle(),
            credits: { enabled: false },
            tooltip: {
                shared: true,
                valueSuffix: ' requests'
            },            
            /*
            tooltip: {
                // Modified formatter to include the description from the point data
                formatter: function () {
                    const point = this.point;
                    let tooltipHtml = `<b>${point.name}</b><br/>Amount: ${NrHelper.toFormattedCurrency(point.y)}`;
                    // Access the custom 'description' property
                    if (point.options && point.options.description) {
                        tooltipHtml += `<br/><span class="text-xs text-gray-400">${point.options.description}</span>`;
                    }
                    return tooltipHtml;
                }
            },
            */  
            xAxis: {
                categories,
                title: { text: 'Month' }
            },
            yAxis: {
                title: { text: 'Number of Requests' },
                min: 0
            },
            legend: { enabled: true },
            plotOptions: {
                column: {
                grouping: true,
                shadow: false,
                borderWidth: 0
                }
            },
            series: [
                {
                name: 'Opened',
                type: 'column',
                data: openedSeries,
                color: this.blueColor
                },
                {
                name: 'Closed',
                type: 'column',
                data: closedSeries,
                color: this.greenColor,
                },
                {
                name: 'Currently Open',
                type: 'line',
                data: Array(categories.length).fill(this.data.open),
                color: this.redColor,
                marker: {
                    enabled: true,
                    radius: 4
                },
                dashStyle: 'ShortDash'
                }
            ]            
        } as unknown as Highcharts.Options;
    }
    
    gotoRoute($event: Highcharts.PointClickEventObject) {
        const point = $event.point as unknown as {routerLink: any[]};
        const routerLink = point.routerLink; 

        if (routerLink) {
            this.router.navigate(routerLink);
        }
    }
}
